import { useSelector } from 'react-redux'
import { view, lensProp } from 'ramda'

export const usePlace = () => {
  return useSelector(view(lensProp(['place'])))
}
